import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { PopoverModule } from 'primeng/popover';
import { ToastModule } from 'primeng/toast';

const PRIME_NG_MODULES = [
    ButtonModule,
    InputTextModule,
    PasswordModule,
    PopoverModule,
    ToastModule,
];

@NgModule({
    imports: [...PRIME_NG_MODULES],
    exports: [...PRIME_NG_MODULES],
})
export class PrimeNgModule {}
